<template>
  <div>
    <v-text-field
      v-model.lazy="valor"
      :label="label"      
      append-icon="get_app"
      prepend-icon="spellcheck"
      prepend-inner-icon="highlight_off"
      v-bind:class="{'input-rejeitado':(arquivoUploadSituacao==1),'input-aprovado':(arquivoUploadSituacao==2)}"
      readonly
      validate-on-blur
      :rules="rules ? rules : []"
      @click:append="baixarArquivo()"
      @click:prepend="aprovarCampo()"
      @click:prepend-inner="abrirModal()"      
      :hint="hint"
      :persistent-hint="persistentHint"
    >
      <template slot="append-outer">
        <v-icon @click="limparArquivoTemp()">clear</v-icon>
      </template>
    </v-text-field>

    <dialogMotivoIndeferimento
      :config="dialogMotivoIndeferimento"
      :permitirMultiplosMotivos="permitirMultiplosMotivos"
      v-on:observacaoOk="fnAcaoModalRejeitar()"
      v-on:observacaoCancel="fnAcaoModalCancelar()"
    />
  </div>
</template>

<script>
import dialogMotivoIndeferimento from "./dialog-motivo-indeferimento";
import fornecedorService from "../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
export default {
  name: "text-field-validador",
  components: { /*Componentes utilizados*/
    dialogMotivoIndeferimento
  },
  props: {//Propriedades que o objeto recebe como parametro
    arquivoUpload: String,
    idFornecedor: String,
    arquivoUploadSituacao: Number,
    idMotivoIndeferimentoArquivo: 0,
    idMotivoIndeferimentoArquivo2: 0,
    idMotivoIndeferimentoArquivo3: 0,
    codDocumento: String,
    label: String,
    rules: Array,
    hint: String,
    "persistent-hint": Boolean,
    permitirMultiplosMotivos: {
      type: Boolean,
      default: true
    }
  },

  watch: { //Propriedades assistidas
    arquivoUpload: {
      handler(newValue) { /*Se houver um novo valor*/
        if (newValue) {
          this.valor = this.subStrUpload(this.arquivoUpload);
        }
      }
    },
  },

  data() {//Declaracao de variaveis
    return {
      valor: this.subStrUpload(this.arquivoUpload),
      dialogMotivoIndeferimento: {
        open: false,
        obs: null,
        titulo: "Motivo",
        motivoSelecionado: null,
        motivoSelecionado2: null,
        motivoSelecionado3: null,
        codDocumento: null
      },
    };
  },

  methods: {//Declaracao de todos os metodos
    abrirModal() {
      this.dialogMotivoIndeferimento.codDocumento = this.codDocumento;
      this.dialogMotivoIndeferimento.motivoSelecionado = this.idMotivoIndeferimentoArquivo;
      this.dialogMotivoIndeferimento.motivoSelecionado2 = this.idMotivoIndeferimentoArquivo2 || null;
      this.dialogMotivoIndeferimento.motivoSelecionado3 = this.idMotivoIndeferimentoArquivo3 || null;
      this.dialogMotivoIndeferimento.open = true;
    },

    aprovarCampo() {
      this.$emit("aprovar");
    },

    fnAcaoModalRejeitar() {
      this.$emit("rejeitar", {
        motivoSelecionado: this.dialogMotivoIndeferimento.motivoSelecionado,
        motivoSelecionado2: this.dialogMotivoIndeferimento.motivoSelecionado2,
        motivoSelecionado3: this.dialogMotivoIndeferimento.motivoSelecionado3
      });
      this.dialogMotivoIndeferimento.open = false;
    },

    fnAcaoModalCancelar() {
      this.dialogMotivoIndeferimento.open = false;
    },
    baixarArquivo() {
      fornecedorService.baixarArquivo(this.arquivoUpload, this.idFornecedor);
    },
    subStrUpload(str) {
      var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

      //Se for link
      if(regex .test(str)) {
        return  str.substring(0,35)+'...';
      }
      return str != null ? str.substring(str.indexOf("_") + 1) : str;
    },
    limparArquivoTemp() {
      this.$emit("clear");
    }
  }
};
</script>

<style>
.input-aprovado .v-input__prepend-outer,
.input-aprovado .v-input__icon,
.input-aprovado .v-text-field__slot,
.input-aprovado .v-input__prepend-inner,
.input-aprovado .v-input__icon--prepend-inner,
.input-aprovado .v-input__slot,
.input-aprovado .v-input__slot::before {
  border-color: #4caf50 !important;
}

.input-rejeitado .v-input__prepend-outer,
.input-rejeitado .v-input__icon,
.input-rejeitado .v-text-field__slot,
.input-rejeitado .v-input__prepend-inner,
.input-rejeitado .v-input__icon--prepend-inner,
.input-rejeitado .v-input__slot,
.input-rejeitado .v-input__slot::before {
  border-color: #ff5252 !important;
}

.v-input__append-outer {
  position: relative;
  left: -45px;
  margin: 0 0 0 -25px;
}
</style>